/* HD versions of the Dither Gradient II library (web_v2/science/gradients/dither-ii/hd),
   de-dithered + upscaled to 1200×800 by a Python pass so the card shader can warp them
   smoothly and re-apply its own dither at screen resolution. `lum` (0–1, average
   luminance) decides whether a card's copy flips to black (light texture) or stays
   white (dark texture) on hover. Gradient 25 is left out: it has text baked in.
   Selected research requests 06, 11, 13, 21, 23 and 26 (light). By the numbers
   uses the dark 10, 16, 28 and 30. */

import { scienceAsset } from 'components/science/scienceAssets';

export type GradientTexture = { id: string; src: string; lum: number };

const grad = (id: string) => scienceAsset(`/gradients/dither-ii/hd/grad_${id}.webp`);

export const GRADIENT_TEXTURES: GradientTexture[] = [
  { id: '01', src: grad('01'), lum: 0.375 },
  { id: '02', src: grad('02'), lum: 0.301 },
  { id: '03', src: grad('03'), lum: 0.308 },
  { id: '04', src: grad('04'), lum: 0.361 },
  { id: '05', src: grad('05'), lum: 0.2 },
  { id: '06', src: grad('06'), lum: 0.672 },
  { id: '07', src: grad('07'), lum: 0.676 },
  { id: '08', src: grad('08'), lum: 0.736 },
  { id: '09', src: grad('09'), lum: 0.556 },
  { id: '10', src: grad('10'), lum: 0.161 },
  { id: '11', src: grad('11'), lum: 0.594 },
  { id: '12', src: grad('12'), lum: 0.259 },
  { id: '13', src: grad('13'), lum: 0.697 },
  { id: '14', src: grad('14'), lum: 0.229 },
  { id: '15', src: grad('15'), lum: 0.592 },
  { id: '16', src: grad('16'), lum: 0.171 },
  { id: '17', src: grad('17'), lum: 0.276 },
  { id: '18', src: grad('18'), lum: 0.329 },
  { id: '19', src: grad('19'), lum: 0.378 },
  { id: '20', src: grad('20'), lum: 0.345 },
  { id: '21', src: grad('21'), lum: 0.795 },
  { id: '22', src: grad('22'), lum: 0.55 },
  { id: '23', src: grad('23'), lum: 0.899 },
  { id: '24', src: grad('24'), lum: 0.313 },
  { id: '26', src: grad('26'), lum: 0.799 },
  { id: '27', src: grad('27'), lum: 0.4 },
  { id: '28', src: grad('28'), lum: 0.202 },
  { id: '29', src: grad('29'), lum: 0.507 },
  { id: '30', src: grad('30'), lum: 0.21 },
  { id: '31', src: grad('31'), lum: 0.5 },
  /* made for the ripple card: soft aqua · periwinkle · lilac · peach fields that
     overlap, so the rings cross colour edges and read clearly */
  { id: 'r1', src: grad('r1'), lum: 0.8 },
];

export const textureById = (id: string): GradientTexture =>
  GRADIENT_TEXTURES.find((g) => g.id === id) ?? GRADIENT_TEXTURES[0]!;

/* the card shader's look, shared by Selected research and By the numbers */
export const CARD_SHADER = {
  amount: 1,
  freq: 1,
  speed: 1,
  zoom: 1.22,
  dither: 0.5,
  ditherSize: 1,
  grain: 0.08,
} as const;
